import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import { PermissionContext, RolePermissions } from "appContext";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";
import { pages } from "views/pages/manage/common/constant";
import rupee from "assets/img/rupee.png";
import invoice from "assets/img/Invoice.png"
import commission from "assets/img/commission.png"
import { ReactComponent as SAPICon } from "assets/img/svg/sapIcon.svg";

const ModuleCards = ({ setListVisible }) => {
    const history = useHistory();

    const ReceiptAccountEntryPermission = RolePermissions(
        useContext(PermissionContext),
        pages["receiptAccountEntry"]["id"]
    );
    const InvoiceAccountEntryPermission = RolePermissions(
        useContext(PermissionContext),
        pages["invoiceAccountEntry"]["id"]
    );
    const AccountPostingControlPermission = RolePermissions(
        useContext(PermissionContext),
        pages["accountPostingControl"]["id"]
    );
        const CommissionReportPermission = RolePermissions(
        useContext(PermissionContext),
        pages?.["commissionReport"]?.["id"]
    );

    const cards = [
        ...(ReceiptAccountEntryPermission?.length
            ? [
                {
                    heading: "Receipt A/C Entry",
                    subHeading: "Add/Edit Receipt and Refund Accounting Details ",
                    icon: <img
                        alt=""
                        src={rupee}
                        height={54}
                        width={54}
                    />,
                    action: () => {
                        //   history.push("/admin/accounting/commissionSlab");
                    },
                },
            ]
            : []),
        ...(InvoiceAccountEntryPermission?.length
            ? [
                {
                    heading: "Invoice A/C Entry",
                    subHeading: "Add/Edit Invoice Accounting Details ",
                    icon: <img
                        alt=""
                        src={invoice}
                        height={49}
                        width={52}
                    />,
                    action: () => {
                        //   history.push("/admin/accounting/commissionSlab");
                    },
                },
            ]
            : []),
                          ...(AccountPostingControlPermission?.length
            ? [
                {
                    heading: "Accounting Posting",
                    subHeading: "Control Data posting to SAP ",
                    icon: <SAPICon
                        alt=""
                        height={54}
                        width={54}
                    />,
                    action: () => {
                        history.push("/admin/accounting/accountPostingControl");
                    },
                },
            ]
            : []),
                    ...(CommissionReportPermission?.length
            ? [
                {
                    heading: "Commission Report",
                    subHeading: "Fortnight Service Charge Report for Franchisees & Sub-contractors",
                    icon: <img
                        src={commission}
                        height={49}
                        width={52}
                    />,
                    action: () => {
                          history.push("/admin/accounting/commissionReport");
                    },
                },
            ]
            : []),
    ];

    return (
        <>
            <div className={`screen-cards-container`}>{getScreenCards(cards)}</div>
        </>
    );
};

export default ModuleCards;
